/**
 * Client-accessible environment config.
 *
 * All values come from VITE_* vars so they are available in the browser.
 */

import packageJson from '../../package.json'

export const config = {
  /** Base URL for client-side API requests.
   *  Uso de `||` (no `??`) para tratar string vacio como "missing" — el
   *  pipeline de QA escribe `.env` con `VITE_API_BASE_URL=` vacio si el
   *  secret no esta configurado, y `?? fallback` no triggerea con ''. */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '/api-be/',

  /** Canonical public URL of this app */
  appUrl: import.meta.env.VITE_APP_URL ?? 'http://localhost:3001',

  /** SignalR hub endpoint */
  signalrUrl: import.meta.env.VITE_SIGNALR_URL ?? '',

  /**
   * Brand / theme key (e.g. 'billeteraPais').
   * Display label is derived via companyLabel below.
   */
  theme: import.meta.env.VITE_THEME ?? 'default',

  /** Company name key — used for theme / feature flags. */
  companyName: import.meta.env.VITE_COMPANY_NAME ?? 'PSP',

  /** Human-readable company label shown in the UI. */
  companyLabel: (import.meta.env.VITE_COMPANY_LABEL as string | undefined)
    || resolveCompanyLabel(import.meta.env.VITE_COMPANY_NAME ?? ''),

  /** Support / contact e-mail shown in error messages */
  supportEmail: import.meta.env.VITE_SUPPORT_EMAIL ?? '',

  /** Mock mode — bypasses real API calls when true */
  isMock: import.meta.env.VITE_MOCK === 'true',

  /** App Store link for the iOS native app (mobile login download CTA). */
  iosAppUrl: import.meta.env.VITE_IOS_APP_URL ?? '',

  /** Google Play link for the Android native app (mobile login download CTA). */
  androidAppUrl: import.meta.env.VITE_ANDROID_APP_URL ?? '',

  /** App version, sourced from package.json. Shown in the mobile login footer. */
  version: packageJson.version as string,
} as const

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

function resolveCompanyLabel(key: string): string {
  const labels: Record<string, string> = {
    billeteraPais: 'Billetera País',
    masPay:        'MasPay',
  }
  return labels[key] ?? key
}
